import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useState } from "react";

import { Modal, Fade } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FileType } from "../../util/enums";
import { ImgBox, Button, CloseIcon, Wrapper, Header, Footer } from "./styles";

export type File = {
  url: string;
  type: string;
};

interface ImageCarouselModalProps {}

export interface ImageCarouselModalHandle {
  handleOpenModal: (currentImgIndex: number, urls?: File[]) => void;
}

const ImageCarouselModal: ForwardRefRenderFunction<
  ImageCarouselModalHandle,
  ImageCarouselModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const [files, setFiles] = useState<File[]>([]);
  const [open, setOpen] = useState<boolean>(false);

  const [currentFile, setCurrentFile] = useState<number>(0);

  const CURRENT_IMAGE_OF_TOTAL = `${Number(currentFile) + 1} ${translate("of")} ${Number(
    files.length
  )}`;

  const handleOpenModal = (currentImgIndex: number, urlsArr?: File[]) => {
    setFiles(urlsArr ?? []);
    setOpen(true);
    setCurrentFile(currentImgIndex);
  };

  const renderFile = () => {
    const file = files[currentFile];

    if (file?.url) {
      if (file.type?.includes(FileType.VIDEO))
        return <video src={file.url} width="100%" height="100%" controls />;

      return <img src={file.url} width="100%" height="100%" />;
    }

    return null;
  };

  const onNextFile = () => {
    if (currentFile >= files.length - 1) return;

    setCurrentFile((state) => state + 1);
  };

  const onPreviousFile = () => {
    if (currentFile === 0) return;

    setCurrentFile((state) => state - 1);
  };

  useImperativeHandle(ref, () => ({
    handleOpenModal,
  }));

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      open={open}
      onClose={() => setOpen(false)}
      closeAfterTransition
    >
      <Fade in={open}>
        <Wrapper>
          <Header>
            <CloseIcon onClick={() => setOpen(false)} />
          </Header>
          <Button isDisabled={currentFile === 0} position="left" onClick={() => onPreviousFile()}>
            {"<"}
          </Button>
          <ImgBox isLoading={!renderFile()}>{renderFile()}</ImgBox>
          <Button
            isDisabled={currentFile === files.length - 1}
            position="right"
            onClick={() => onNextFile()}
          >
            {">"}
          </Button>
          <Footer>
            <span>{CURRENT_IMAGE_OF_TOTAL}</span>
          </Footer>
        </Wrapper>
      </Fade>
    </Modal>
  );
};

export default forwardRef(ImageCarouselModal);
